import "./AboutUs.css";
import React from "react";
import PageHeader from "../../components/pageheader/pageheader";
import CompanyBanner from "../../components/companybanner/companybanner";
import CtaTab from "../../components/ctatab/ctatab";
import { SiTicktick } from "react-icons/si";

function AboutUs() {
  return (
    <>
      {" "}
      <PageHeader title="About" />
      <CompanyBanner />
      <section className="company-section">
        <div className="container company-container">
          <div className="vision-section">
            <h2 className="about-title">วิสัยทัศน์</h2>
            <p>
              มุ่งสู่การเป็นบริษัทชั้นนำด้านการให้บริการโซลูชันครบวงจร
              ที่ช่วยให้ธุรกิจของลูกค้าสามารถแข่งขันและเติบโตได้อย่างยั่งยืนในยุคดิจิทัล
              ด้วยการผสานนวัตกรรม เทคโนโลยีล้ำสมัย
              และการบริการที่เน้นคุณค่าและความพึงพอใจของลูกค้าเป็นสำคัญ
            </p>
          </div>
          <div className="mission-section">
            <h2 className="about-title">พันธกิจ</h2>
            <ul>
              <li>
                <span className="tick">
                  <SiTicktick />
                </span>
                พัฒนาผลิตภัณฑ์และบริการที่ตอบโจทย์ความต้องการของลูกค้า
              </li>
              <li>
                <span className="tick">
                  <SiTicktick />
                </span>
                สร้างความเชื่อมั่นและความพึงพอใจสูงสุดให้กับลูกค้า
              </li>
              <li>
                <span className="tick">
                  <SiTicktick />
                </span>
                ผลักดันทีมงานให้มีความรู้ ความสามารถ และเติบโตไปพร้อมกับองค์กร
              </li>
              <li>
                <span className="tick">
                  <SiTicktick />
                </span>
                มุ่งเน้นความยั่งยืน ทั้งในด้านเศรษฐกิจ สังคม และสิ่งแวดล้อม
              </li>
            </ul>
          </div>
        </div>
      </section>
      <CtaTab />
    </>
  );
}

export default AboutUs;
